import { isKit } from "./is-kit";

export function getProductSeason(product: any) {
  if (!product) {
    return null;
  }
  let { season } = product.extendedDescription;
  if (isKit(product)) {
    const seasonProduct = product.extendedDescription.components.find((component: any) => component.extendedDescription?.season);
    season = seasonProduct ? seasonProduct.extendedDescription.season : season;
  }
  return season;
}
